export default __webpack_public_path__ + "static/media/create_service.8088b473.svg";